import { AddAccessoryInitialVisitQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addAccessoryInitialVisit/addAccessoryInitialVisitQuery.type';
import { addAccessoryInitialVisitFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addAccessoryInitialVisit/addAccessoryInitialVisitQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useAddAccessoryInitialVisitQueryOptions = () => {
  return useMutation({
    mutationKey: ['addAccessoryInitialVisitQueryOptions'],
    mutationFn: (params: AddAccessoryInitialVisitQueryParamsType) =>
      addAccessoryInitialVisitFunction(params),
  });
};
